import { createSelector } from 'reselect';
import { standortStateSelector } from '../standort';
import { pendingResponse } from '../../fetchStatus';

export const couponsResponseSelector = createSelector(
    [standortStateSelector],
    couponState => couponState.coupons ?? pendingResponse
);
